<template>
  <el-dialog id="popup_dialog" title="Produse" :visible.sync="showPopup" class="my-dialog-class custom-width">
    <div class="container">
          <el-form
      label-position="top"
      :inline="false"
      :rules="rules"
      label-width="100%"
      :model="selectedObject"
      ref="my-form"
      @submit.prevent="save"
      v-loading="loadingVisible"
    >
      <el-row :gutter="15">
        <el-col :md="6">
          <el-form-item label="Id Evio" prop="IdEvio">
            <el-input class="full-width" v-model="selectedObject.IdEvio" />
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="Nume" prop="Nume">
            <el-input class="full-width" v-model="selectedObject.Nume" />
          </el-form-item>
        </el-col> 

        <el-col :md="6">
          <el-form-item label="Centru productie" prop="IdCentruProductie">
            <el-select v-model="selectedObject.IdCentruProductie" class="full-width" @change="handleSelectCentru()">
              <el-option
                v-for="item in Info.centre_productie"
                :key="'centre_productie' + item.Id"
                :label="item.Nume"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="Categorie" prop="IdCategorie">
            <el-select v-model="selectedObject.IdCategorie" class="full-width">
              <el-option
                v-for="item in Info.categorii_produse_centru"
                :key="'categorii_produse' + item.Id"
                :label="item.Nume"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4">
          <el-form-item label="Pret Normal">
            <el-input-number
              class="full-width"
              v-model="selectedObject.Pret"
              :precision="2"
              :max="999999"
            ></el-input-number>
          </el-form-item>      
          </el-col>
        <el-col :md="4"> 
          <el-form-item label="Pret Autoutilitar">
            <el-input-number
              class="full-width"
              v-model="selectedObject.PretAutoutilitar"
              :precision="2"
              :max="999999"
            ></el-input-number>
          </el-form-item>      
          </el-col>
        <el-col :md="4">    
          <el-form-item label="Pret SUV">
            <el-input-number
              class="full-width"
              v-model="selectedObject.PretSUV"
              :precision="2"
              :max="999999"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :md="4">    
          <el-form-item label="Pret Supercar">
            <el-input-number
              class="full-width"
              v-model="selectedObject.PretSupercar"
              :precision="2"
              :max="999999"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :md="3">
          <el-form-item label="Serviciu">
            <el-checkbox
              v-model="selectedObject.Serviciu"
              true-label="1"
              false-label="0"
            >
              Serviciu
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :md="3">
          <el-form-item label="Dezactivat">
            <el-checkbox
              v-model="selectedObject.Dezactivat"
              true-label="1"
              false-label="0"
            >
              Dezactivat
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="Timp montaj">
            <el-input-number
              class="full-width"
              v-model="selectedObject.TimpMontaj"
              :step="60"
              :min="0"
              :max="999999"
            ></el-input-number>
          </el-form-item>      
        </el-col>
        <el-col :md="6">
          <el-form-item label="Cost montaj">
            <el-input-number
              class="full-width"
              v-model="selectedObject.CostMontaj"
              :step="1"
              :min="0"
              :max="999999"
              :disabled="selectedObject.TimpMontaj == 0"
              :precision="2"
            ></el-input-number>
          </el-form-item>      
        </el-col>
        <el-col :md="24">
          <el-form-item label="Descriere" prop="Descriere">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 7}" class="full-width" v-model="selectedObject.Descriere" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showPopup = false"> Renunta </el-button>
      <el-button type="primary" @click="save"> Salveaza </el-button>
    </span>
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Produse_dialog",
  extends: BasePage,
  data() {
    return {
      baseUrl: "",
      showPopup: false,
      mode: "add",
      selectedObject: {
        IdEvio: "",
        IdCategorie: "",
        IdCentruProductie: "",
        Nume: "",
        Descriere: "",
        Pret: "",
        PretAutoutilitar: "",
        PretSUV: "",
        PretSupercar: "",
        Serviciu: "",
        Dezactivat: "",
        TimpMontaj: "",
        CostMontaj: "",
      },
      Info: {
        categorii_produse: [],
        categorii_produse_centru: [],
        centre_productie: [],
      },
      rules: {
        IdEvio: [{ required: true, message: "Campul este obligatoriu", trigger: 'blur' }],
        IdCategorie: [{ required: true, message: "Campul este obligatoriu" }],
        IdCentruProductie: [{ required: true, message: "Campul este obligatoriu" }],
        Nume: [{ required: true, message: "Campul este obligatoriu" }],
      },
    };
  },
  methods: {
    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.selectedObject= {
          IdEvio: "",
          IdCategorie: "",
          IdCentruProductie: "",
          Nume: "",
          Descriere: "",
          Pret: "",
          PretAutoutilitar: "",
          PretSUV: "",
          PretSupercar: "",
          Serviciu: "",
          Dezactivat: "",
          TimpMontaj: "",
          CostMontaj: "",
        }
      } else {
        this.mode = "edit";
        var result = await this.post("admin/produse/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
      }

    },
     handleSelectCentru() {
      
      this.selectedObject.IdCategorie = '';
      this.Info.categorii_produse_centru = this.Info.categorii_produse.filter((value) => value.IdCentruProductie == this.selectedObject.IdCentruProductie)
      // console.log(this.Info.categorii_produse_centru)
    },
    async get_info() {
      var response = await this.post("admin/produse/get_info_for_dialog");
      this.Info.categorii_produse = response.categorii_produse;
      this.Info.categorii_produse_centru = response.categorii_produse;
      this.Info.centre_productie = response.centre_productie;
      
    },
    save: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          await this.post("admin/produse/save", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.selectedObject= {};
          this.$emit("save");
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less">

</style>